import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue';
import Banner from '@components/Banner/Banner.vue';
import { Checkbox } from '@components/Form/Checkbox';
import LabeledInput from '@components/Form/LabeledInput/LabeledInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PrivateRegistry',
  props: {
    value: {},
    enabled: { type: Boolean },
    mode: {},
    rules: {},
    checkboxTestId: {},
    inputTestId: {}
  },
  emits: ["update:value", "update:enabled"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showInput = ref(!!props.value);

watch(() => props.enabled, (neu) => {
  if (typeof neu === 'boolean' && neu !== showInput.value) {
    showInput.value = neu;
  }
});

watch(showInput, (neu, old) => {
  if (neu !== props.enabled) {
    emit('update:enabled', neu);
  }
  if (!neu && old && props.value) {
    emit('update:value', null);
  }
});

watch(() => props.value, (neu) => {
  if (!!neu && !showInput.value) {
    showInput.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Banner, {
      color: "info",
      class: "mt-0",
      "label-key": "cluster.privateRegistry.importedDescription"
    }),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createVNode(_unref(Checkbox), {
      value: showInput.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((showInput).value = $event)),
      class: "mb-20",
      mode: __props.mode,
      label: _ctx.t('cluster.privateRegistry.label'),
      "data-testid": __props.checkboxTestId
    }, null, 8, ["value", "mode", "label", "data-testid"]),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (showInput.value)
      ? (_openBlock(), _createBlock(LabeledInput, {
          key: 0,
          value: __props.value as string,
          mode: __props.mode,
          rules: __props.rules,
          required: true,
          "label-key": "catalog.chart.registry.custom.inputLabel",
          "data-testid": __props.inputTestId,
          placeholder: _ctx.t('catalog.chart.registry.custom.placeholder'),
          "onUpdate:value": _cache[1] || (_cache[1] = (val) => emit('update:value', val))
        }, null, 8, ["value", "mode", "rules", "data-testid", "placeholder"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})